import { LIST_TABLE_ROW_HEIGHT_CLASS } from '@/components/shared/ListPagination';
import { TABLE_BODY_ROW_BORDER_CLASS } from '@/components/ui/responsive-table/columnLayout';
import { cn } from '@/lib/utils';

interface TableSpacerRowsProps {
  count: number;
  columnCount: number;
  cellPad: string;
}

/** Placeholder rows — same height as data rows, no pointer events. */
export function TableSpacerRows({ count, columnCount, cellPad }: TableSpacerRowsProps) {
  if (count <= 0) return null;

  return (
    <>
      {Array.from({ length: count }, (_, rowIdx) => (
        <tr
          key={`__table-spacer-${rowIdx}`}
          className={cn(TABLE_BODY_ROW_BORDER_CLASS, 'pointer-events-none')}
          aria-hidden
        >
          {Array.from({ length: columnCount }, (_, colIdx) => (
            <td
              key={colIdx}
              className={cn(cellPad, LIST_TABLE_ROW_HEIGHT_CLASS, 'p-0 align-middle')}
            >
              <span className="invisible select-none" aria-hidden>
                &nbsp;
              </span>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
